import { useAuth, GetUserToken } from 'components/AuthProvider';
import { useQuery, QueryConfig, TypedQueryFunction } from 'react-query';
import { getClientSdk } from 'graphql/client';
import { BoxFragment } from 'generated/graphql';
import { GraphQLError } from 'graphql-request/dist/types';
import { useSnackbar } from 'notistack';

export type Box = {
  id: number;
  name: string;
  imei: string;
  coords: google.maps.LatLng;
  address: string | null;
  postcode: string | null;
  prefectureName: string | null;
};

export type Boxes = { boxes: Box[]; boxBounds: google.maps.LatLngBounds };

export const BoxesKey = 'boxes';

const getLatLng = (p: Boxes, c: BoxFragment) => {
  const latLng = new google.maps.LatLng(
    c.coords.coordinates[1],
    c.coords.coordinates[0]
  );
  p.boxes.push({
    id: c.id,
    name: c.name,
    imei: c.imei,
    coords: latLng,
    address: c.address ?? null,
    postcode: c.postcode ?? null,
    prefectureName: c.prefectureByPrefecture?.name ?? null,
  });
  p.boxBounds.extend(latLng);
  return p;
};

const getBoxes = (
  getUserToken: GetUserToken
): TypedQueryFunction<Boxes, [typeof BoxesKey]> => async (key) => {
  const token = await getUserToken();
  const { box } = await getClientSdk(token).Boxes();

  const initData: Boxes = {
    boxes: [],
    boxBounds: new google.maps.LatLngBounds(),
  };

  const data = box.reduce<Boxes>(getLatLng, initData);

  return data;
};

export const useBoxes = (options?: QueryConfig<Boxes, GraphQLError>) => {
  const { getUserToken } = useAuth();

  const { enqueueSnackbar } = useSnackbar();

  return useQuery(BoxesKey, getBoxes(getUserToken), {
    ...options,
    onError: () => {
      enqueueSnackbar('ボックスが読み取れませんでした', { variant: 'error' });
    },
  });
};

export default useBoxes;
